import React, { useState } from 'react'
import { Divider, Hidden, IconButton, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import cx from 'classnames'
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded'
import { InlineEdit } from '../../../../../../../../../../components/InlineEdit/InlineEdit'
import { ConfirmationDialog } from '../../../../../../../../../../components/ConfirmationDialog/ConfirmationDialog'
import { useHoverOpacity } from '../../../../../../../../../../hooks/useHoverOpacity'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      display: 'none',
    },
    stat: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    mod: {
      marginLeft: '6px',
      fontSize: '0.9em',
      width: 20,
      height: 20,
      color: theme.palette.mode === 'dark' ? '#c2c2c2' : '#000',
      backgroundColor: theme.palette.mode === 'dark' ? '#313131' : '#d0d0d0',
    },
    red: {
      color: '#eb0014',
    },
    green: {
      color: '#44b700',
    },
  })
)

interface RollButtonProps {
  isRolling: boolean
  onClick: () => void
}

const RollButton: React.FC<RollButtonProps> = ({ isRolling, onClick }) => {
  return (
    <IconButton size="small" disabled={isRolling} onClick={onClick}>
      <CasinoRoundedIcon color={'primary'} fontSize={'small'} />
    </IconButton>
  )
}

interface Props {
  name: string
  value: number
  onStatRoll?: () => void
  isRolling: boolean
  editable?: boolean
  onEdit?: (value: string) => void
}

export const SkillItem: React.FC<Props> = ({
  name,
  value,
  onStatRoll,
  isRolling,
  editable,
  onEdit,
}) => {
  const classes = useStyles()
  const [editMode, setEditMode] = useState<boolean>()
  const { onMouseEnter, onMouseLeave, hoverClass } = useHoverOpacity()

  return (
    <>
      <div
        className={cx(classes.stat, hoverClass)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div>{name}</div>
        <div className={classes.stat}>
          {editMode && editable && (
            <InlineEdit
              defaultValue={String(value)}
              onEdit={v => {
                setEditMode(false)
                onEdit && onEdit(v)
              }}
              onCancel={() => setEditMode(false)}
            />
          )}
          <span
            onClick={() => editable && setEditMode(true)}
            className={cx(editMode && classes.hidden)}
          >
            {value}
          </span>
          {onStatRoll && (
            <>
              <Hidden mdDown>
                <RollButton isRolling={isRolling} onClick={onStatRoll} />
              </Hidden>
              <Hidden mdUp>
                <ConfirmationDialog
                  body={
                    <div>
                      {'Wykonać rzut na umiejętność '}
                      <strong>{name.toLowerCase()}</strong>
                      {'?'}
                    </div>
                  }
                >
                  {(confirm: any) => (
                    <RollButton
                      isRolling={isRolling}
                      onClick={confirm((e: any) => () =>
                        new Promise(r => {
                          onStatRoll()
                          return r('ok')
                        })
                      )}
                    />
                  )}
                </ConfirmationDialog>
              </Hidden>{' '}
            </>
          )}
        </div>
      </div>
      <Divider />
    </>
  )
}
